import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import dataV from '@jiaminghi/data-view';
// 引入全局css
import './assets/scss/style.scss';
// 引入图表（所有图标见 icon 目录下的 demo_index.html）
import './assets/icon/iconfont.css'
// 引入 全局注册组件
import PublicComponent from '@/components/componentInstall';
import {globalRegister}  from '@/components/elementInstall';
import scroll from "vue-seamless-scroll/src";
import vue3SeamlessScroll from "vue3-seamless-scroll/dist/vue3-seamless-scroll";
// import 'lib-flexible/flexible'
import {useFlexibleRem} from "@/utils/flexible"
useFlexibleRem()

const app = createApp(App)
app.use(PublicComponent)
app.use(scroll)
app.use(dataV)
app.use(store)
app.use(router)
app.use(globalRegister)
app.use(vue3SeamlessScroll)

// installElementPlus(app)
app.mount('#app')
